/* =========================================================
   Jaci Store · Landing Mullein (secciones jm-*)
   JavaScript nativo, sin librerías.
   IMPORTANTE: este archivo NO toca los botones de compra.
   Los botones .jm-buy abren EasySell solo por la clase
   es-popup-button-overwrite; aquí no se les agrega ningún clic.
   ========================================================= */
(function () {
  if (window.JMLanding) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- Galería / carrusel ---------- */
  function initGallery(g) {
    if (!g || g.dataset.jmReady) return;
    g.dataset.jmReady = '1';
    var track = g.querySelector('.jm-gal__track');
    if (!track) return;
    var slides = g.querySelectorAll('.jm-gal__slide');
    var thumbs = g.querySelectorAll('.jm-gal__thumb');
    var count = g.querySelector('[data-jm-count]');
    var n = slides.length;
    var idx = 0;
    var target = null;

    function setActive(i) {
      idx = i;
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      if (count) count.textContent = (i + 1) + ' / ' + n;
    }
    function go(i) {
      if (!n) return;
      i = (i + n) % n;
      target = i;
      track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      setActive(i);
    }
    g.go = go;
    g.current = function () { return idx; };

    var prev = g.querySelector('.jm-gal__prev');
    var next = g.querySelector('.jm-gal__next');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(Number(t.dataset.index)); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (target !== null) {
          if (i === target) target = null; else return;
        }
        if (i !== idx && i >= 0 && i < n) setActive(i);
      });
    }, { passive: true });

    window.addEventListener('resize', function () {
      track.scrollTo({ left: idx * track.clientWidth, behavior: 'auto' });
    });

    initLightbox(g, go);
    setActive(0);
  }

  /* ---------- Ampliación (lightbox) ---------- */
  function initLightbox(scope, onChange) {
    var dlg = scope.querySelector('.jm-lightbox');
    var triggers = scope.querySelectorAll('[data-jm-zoom]');
    if (!dlg || !triggers.length || typeof dlg.showModal !== 'function') return;
    var img = dlg.querySelector('.jm-lightbox__img');
    var list = Array.prototype.map.call(triggers, function (t) {
      return { src: t.getAttribute('data-jm-zoom'), alt: t.getAttribute('data-jm-alt') || '' };
    });
    var cur = 0;
    function show(i) {
      cur = (i + list.length) % list.length;
      img.src = list[cur].src;
      img.alt = list[cur].alt;
    }
    triggers.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); dlg.showModal(); });
    });
    var c = dlg.querySelector('.jm-lightbox__close');
    var p = dlg.querySelector('.jm-lightbox__nav--prev');
    var nx = dlg.querySelector('.jm-lightbox__nav--next');
    if (c) c.addEventListener('click', function () { dlg.close(); });
    if (p) p.addEventListener('click', function () { show(cur - 1); });
    if (nx) nx.addEventListener('click', function () { show(cur + 1); });
    if (list.length < 2) { if (p) p.hidden = true; if (nx) nx.hidden = true; }
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(cur - 1);
      if (e.key === 'ArrowRight') show(cur + 1);
    });
    dlg.addEventListener('close', function () {
      if (onChange) onChange(cur);
    });
  }

  /* ---------- Tarjetas de ofertas (selección informativa) ---------- */
  function fmt(n) { return '$' + Number(n).toLocaleString('es-CL'); }
  function initOffers(box) {
    if (!box || box.dataset.jmReady) return;
    box.dataset.jmReady = '1';
    var scope = box.closest('[data-jm-offer-scope]') || box;
    var cards = box.querySelectorAll('.jm-offer');
    var label = scope.querySelector('[data-jm-sel-label]');
    var total = scope.querySelector('[data-jm-sel-total]');
    var reminder = scope.querySelector('[data-jm-sel-reminder]');
    function select(card) {
      cards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
      });
      if (label) label.textContent = card.dataset.label || '';
      if (total && card.dataset.price) total.textContent = fmt(card.dataset.price);
      if (reminder) reminder.textContent = card.dataset.label || '';
      document.querySelectorAll('[data-jm-sticky-label]').forEach(function (el) { el.textContent = card.dataset.label || ''; });
      document.querySelectorAll('[data-jm-sticky-total]').forEach(function (el) { if (card.dataset.price) el.textContent = fmt(card.dataset.price); });
    }
    cards.forEach(function (c, i) {
      c.addEventListener('click', function () { select(c); });
      c.addEventListener('keydown', function (e) {
        var k = e.key, j = null;
        if (k === 'ArrowDown' || k === 'ArrowRight') j = i + 1;
        if (k === 'ArrowUp' || k === 'ArrowLeft') j = i - 1;
        if (j !== null) {
          e.preventDefault();
          j = (j + cards.length) % cards.length;
          cards[j].focus(); select(cards[j]);
        }
      });
    });
    var initial = box.querySelector('.jm-offer.is-selected') || cards[0];
    if (initial) select(initial);
  }

  /* ---------- Animaciones de entrada ---------- */
  var revealObs = null;
  function initReveal(root) {
    if (reduceMotion || designMode || !('IntersectionObserver' in window)) return;
    if (!revealObs) {
      revealObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); revealObs.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    root.querySelectorAll('.jm[data-jm-anim]').forEach(function (s) {
      if (s.dataset.jmAnimReady) return;
      s.dataset.jmAnimReady = '1';
      s.classList.add('jm-anim');
      s.querySelectorAll('.jm-reveal').forEach(function (el) { revealObs.observe(el); });
    });
  }

  /* ---------- Navegación interna ---------- */
  function initNav(nav) {
    if (!nav || nav.dataset.jmReady) return;
    nav.dataset.jmReady = '1';
    var links = nav.querySelectorAll('a[href^="#"]');
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var el = id && document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        var offset = nav.classList.contains('is-sticky') ? nav.offsetHeight + 8 : 8;
        var y = el.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: reduceMotion ? 'auto' : 'smooth' });
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });
    if (!('IntersectionObserver' in window)) return;
    var map = {};
    links.forEach(function (a) {
      var id = a.getAttribute('href').slice(1);
      var el = id && document.getElementById(id);
      if (el) map[id] = a;
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var a = map[en.target.id];
        if (!a) return;
        if (en.isIntersecting) {
          links.forEach(function (l) { l.classList.remove('is-active'); });
          a.classList.add('is-active');
        }
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    Object.keys(map).forEach(function (id) { io.observe(document.getElementById(id)); });
  }

  /* ---------- Barra fija de compra ---------- */
  function initSticky(bar) {
    if (!bar || bar.dataset.jmReady) return;
    bar.dataset.jmReady = '1';
    var watched = Array.prototype.slice.call(document.querySelectorAll('[data-jm-buy-watch]'));
    if (!watched.length) return;
    var first = watched[0];
    var ticking = false;
    if (bar.classList.contains('jm-sticky--mobile-only')) document.body.classList.add('jm-sticky-mobile-only');
    function inView(el) {
      var r = el.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight && r.width > 0;
    }
    function update() {
      ticking = false;
      var passed = first.getBoundingClientRect().bottom < 0;
      var anyVisible = watched.some(inView);
      var show = passed && !anyVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('button').forEach(function (btn) { btn.tabIndex = show ? 0 : -1; });
      document.body.classList.toggle('jm-has-sticky', show);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-jm-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-jm-offers]').forEach(initOffers);
    root.querySelectorAll('[data-jm-nav]').forEach(initNav);
    root.querySelectorAll('[data-jm-lightbox-scope]').forEach(function (s) {
      if (s.dataset.jmReady) return; s.dataset.jmReady = '1'; initLightbox(s);
    });
    document.querySelectorAll('[data-jm-sticky]').forEach(initSticky);
    initReveal(root);
  }

  window.JMLanding = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
